module.exports = __webpack_public_path__ + "static/media/6585-r-en.b37d1911.png";